/*
 * @Author: liusihan
 * @Date: 2020-09-11 09:09:03
 * @LastEditTime: 2022-02-16 11:19:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\service\index.ts
 */
import axios from 'axios'
import { Notification, Loading } from 'element-ui'
import { ServiceStatus } from '../commons/enums'
import { getToken } from '@/utils/cookies'
let loadingInstance: any = ''
// multipart/form-data
const hideLoadingUrl = ['/api/v1/core/learningrecord/trace/video/', '/api/v1/core/learningrecord/trace/initialize/', '/api/v1/admin/learnProcessRecord/', '/api/v1/users/learning-plans/?page=1&size=100']

const uploadFileWhites = ['/api/v1/admin/enterprise/order/basket/student/import']
// const loadingInstance = Loading.service({ fullscreen: true })
console.log(process.env.VUE_APP_SELECTEDCOURSE_API)
const instance = axios.create({
  baseURL: process.env.VUE_APP_SELECTEDCOURSE_API,
  headers: {
    // 'Content-type': 'application/json'
    'Content-Disposition': 'form-data; name=file'
  },
  timeout: 50000
})

// application/x-www-form-unlencoded

// 请求拦截器
instance.interceptors.request.use(config => {
  if (!hideLoadingUrl.includes((config.url as string)) && !(config.url as string).includes('/api/v1/admin/businessorder/')) {
    loadingInstance = Loading.service({ fullscreen: true, text: '加载中', background: 'rgba(233, 233, 255 .1)' })
  }
  if (getToken()) {
    config.headers.common.Authorization = `Bearer ${getToken()}`
  }
  return config
})

// 响应拦截器
instance.interceptors.response.use(response => {
  loadingInstance && loadingInstance.close()
  // 没权限到登陆页
  if (response.data.status && response.data.status !== ServiceStatus.SUCCESS) {
    Notification({ title: '错误提示', type: 'error', message: response.data.msg })
    if (response.data.msg.includes('重新登录')) {
      const page = window.location.pathname
      localStorage.setItem('gobackPage', page)
      window.location.href = '/login.html'
    }
    return Promise.reject(new Error(response.data.msg))
  }
  return response.data
}, err => {
  loadingInstance && loadingInstance.close()
  if (err.message.indexOf('401') > 0) {
    Notification({ title: '错误提示', type: 'error', message: '请重新登录' })
    window.location.href = '/login.html'
    return
  }
  if (err.message.indexOf('404') > 0) {
    return
  }
  if (err.message.indexOf('405') > 0) {
    Notification({ title: '错误提示', type: 'error', message: err.message })
    // return
  }
  if (err.message.indexOf('500') > 0) {
    // return
    Notification({ title: '错误提示', type: 'error', message: err.message })
  }
  if (err.message.indexOf('502') > 0) {
    return
  }
  return Promise.reject(err)
})

export default instance
